<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class=" mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/issuetracking/index">  {{language[1]['Home']}}</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[5]['Manage Contractor']}}</h6>
 
  <!-- <h6 class="custom-maintitle "><b>Issue Tracking</b></h6> -->

  <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>{{language[11]['Showing ']}} {{currentPage}}-{{currentPage*perPage}} {{language[12]['of ']}} {{totalRows}} {{language[13]['items']}}.</b></span>
  </div>

        </div>
  


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

    

    <button  @click="ContractorCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">    {{language[53][' Create Contractor']}}</button>


</div>
</div>



<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body ">
 

  <b-table responsive style="font-size: small;"   class="table-hover"
      :items="all_data"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
        head-variant="dark"
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
     
    >
   

    <!-- @filtered="onFiltered" -->
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template #cell(actions)="row">

        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    {{language[77]['Action']}}
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor"@click="viewLoad(row.item.id)"  v-show="row.item.status!=13" >{{language[28]['View']}}</a>
    <a class="dropdown-item mouse-cursor"@click="Update(row.item.id)"   >{{language[78]['Update']}}</a>
    <a class="dropdown-item mouse-cursor"@click="inactive(row.item.id)"  v-show="row.item.status==1"  >{{language[56]['Inactive']}}</a>
    <a class="dropdown-item mouse-cursor"@click="active(row.item.id)"  v-show="row.item.status==2"  >{{language[55]['Active']}}</a>
   
   
  </div>
</div>
      
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        
        <!-- <button @click="viewLoad(row.item.id)"  v-show="row.item.status!=13" size="sm"  class="btn mr-1 custom-btn btn-primary btn-sm mb-1 font-size_def bdr-rad">
          View
        </button>
        <button  size="sm"  class="btn mr-1 custom-btn btn-warning btn-sm mb-1 font-size_def bdr-rad">
          Allocated
        </button>
        <button  size="sm"  class="btn mr-1 wip-btn custom-btn  btn-sm mb-1 font-size_def bdr-rad">
          WIP
        </button>
        <button  size="sm"  class="btn mr-1 outsourced-btn custom-btn  btn-sm mb-1 font-size_def bdr-rad">
          Outsourced
        </button>
        <button @click="fixMy(row.item.id)"  v-show="row.item.status!=13" size="sm"  class="btn mr-1 custom-btn btn-success btn-sm mb-1 font-size_def bdr-rad">
         Fixed
        </button> -->
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>

      

  
    
    

  
</div>
</div>
</div>
<br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
 import httpClient from '@/axios';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        all_data:[],
        fields:[],
       
       
      


        
      }

    },
    computed: {
     
    },

    created(){
      this.loadIssue();
    },
    mounted(){
     
      
      this.fields= [
          { key: 'name1', label: this.language[34]['Name'], sortable: true, },
          { key: 'mobile', label: this.language[75]['Mobile'], sortable: true,  },
          { key: 'email', label: this.language[76]['Email'], sortable: true  },
          { key: 'work_typ1', label: this.language[16]['Main Category'], sortable: true  },
          { key: 'work_typ2', label: this.language[17]['Sub Category'], sortable: true  },
         
          { key: 'status1', label: this.language[22]['Status'], sortable: true  },
          { key: 'created_date', label: this.language[23]['Created Date'], sortable: true  },
         
          
          { key: 'actions', label: this.language[24]['Actions'],  }
        ];


    },
methods : {
  viewLoad(id){
    this.$router.push('/contractors/view?id='+id);
  },
  Update(id){
    this.$router.push('/contractors/update?id='+id);
  },
  ContractorCreate(){
    this.$router.push('/contractors/create');
  },

  loadIssue(id) {

this.filterOn = id;
  },

  // onFiltered(filteredItems) {
  //       // Trigger pagination to update the number of buttons/pages due to filtering
  //       this.totalRows = filteredItems.length
  //       this.currentPage = 1
  //     },
      async fixMy(id) {
    console.log(this.access_token);
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/fix?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       if(data.status==200){
        this.loadIssue();
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async inactive(id) {
  
    try {
      const { data} = await  httpClient.get('/web/api/contractors/inactive?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       if(data.status==200){
        this.loadIssue();
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },
  async active(id) {
  
    try {
      const { data} = await  httpClient.get('/web/api/contractors/active?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       if(data.status==200){
        this.loadIssue();
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async loadIssue() {
    console.log(this.access_token);
    try {
      const { data} = await  httpClient.get('/web/api/contractors/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
         this.all_data = data.all_data;
        this.totalRows =  this.all_data.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>